<template>
  <div class="feedback-container">
    <div class="area">
      <div class="row" v-animated-show="utils.handleScroll">
        <h2 class="col-12 col-md-12" v-html="title"></h2>
        <div class="col-8 col-md-12 avatars">
          <div class="avatars-container">
            <img
              :src="l.avatar"
              class="avatar"
              ref="avatar"
              v-for="(l, i) in orderedList"
              :key="i"
              :class="[
                {
                  current: current === i,
                  past: current > i,
                  hidden: i - current >= list.length,
                },
              ]"
              :style="{
                transform: `translateX(${(-186 - 27) * (i - current) +
                  (i - current !== 0 ? -64 : 0)}px)`,
              }"
            />
          </div>
        </div>
        <section
          class="feedback-item col-4 col-md-12"
          v-for="(l, i) in orderedList"
          :key="i"
          :class="[{ current: current === i }]"
        >
          <div class="row">
            <div class="quotes icon-quotes"></div>
            <Description
              class="default feedback col-12"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.user"
              :more="l.company"
              :desc="l.desc"
              :button="l.button"
              :href="l.href"
              :icon="l.icon"
              v-if="l.user"
            />
          </div>
        </section>
        <div class="nav-arrows col-4 col-md-4">
          <a
            class="nav-arrow nav-arrow--prev"
            href="/"
            @click.prevent="
              () => {
                nextFeedback(-1);
              }
            "
          ></a>
          <a
            class="nav-arrow nav-arrow--next"
            href="/"
            @click.prevent="
              () => {
                nextFeedback(1);
              }
            "
            v-show="current !== orderedList.length - 1"
          ></a>
        </div>
        <div class="float-art-right2"></div>
        <!-- <a class="button-more col-12" href="/add">Добавить отзыв</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import { setTimeout } from "timers";
export default {
  name: "Feedback",
  props: {
    theme: {
      default: "default",
    },
    title: String,
    list: Array,
    cons: Array,
  },
  data() {
    return {
      orderedList: [],
      utils: utils,
      current: 1,
      stopAnimation: false,
      animating: false,
      queue: [],
    };
  },
  methods: {
    nextFeedback(offset) {
      // if (offset < 0) {
      //   this.orderedList.push(this.orderedList.shift());
      // } else {
      //   this.orderedList.push(this.orderedList.shift());
      // }
      if (!this.animating) {
        this.animating = true;
        var next =
          (this.current + offset + this.orderedList.length) %
          this.orderedList.length;
        if (next === this.list.length + 1) {
          this.setAnimationEnabled(false);
          this.current = 0;
          next = 1;
        }
        if (next === 0) {
          this.setAnimationEnabled(false);
          next = this.list.length;
          this.current = this.list.length + 1;
        }
        setTimeout(() => {
          this.setAnimationEnabled(true);
          this.current = next;
          setTimeout(() => {
            this.animating = false;
            if (this.queue.length > 0) {
              this.nextFeedback(this.queue.shift());
            }
          }, 350);
        }, 100);
      } else {
        if (this.queue.length == 0) {
          this.queue.push(offset);
        }
      }
    },
    updated() {
      console.log(123);
    },
    setAnimationEnabled(enabled) {
      this.$refs.avatar.forEach(element => {
        element.style.transition = enabled ? "all 0.4s" : "unset"; // element.scrollHeight;
      });
    },
  },
  created() {
    this.orderedList = [
      this.list[this.list.length - 1],
      ...this.list,
      ...this.list,
    ];
  },
  mounted() {
    this.current = 1;
  },
  components: {},
};
</script>

<style lang="scss">
.feedback-container {
  background: #f7f7f7;
  h2 {
    font-weight: bold;
    @media all and (max-width: $md) {
      font-size: 24px;
    }
  }
  @extend %page-block;
  .row {
    grid-row-gap: 28px;
    .button-description {
      width: 214px;
      margin-top: 28px;
    }
  }
  .avatars {
    @media all and (max-width: $md) {
      grid-row: 3;
      grid-column: 1 / span 12;
      height: 224px;
      justify-items: center;
      justify-content: center;
    }
    display: grid;
    height: 448px;
    justify-items: flex-end;
    justify-content: flex-end;
    align-content: flex-end;
    align-items: flex-end;
    align-self: flex-end;
    width: 100%;
    grid-row: 2;
    grid-column: 1 / span 8;
    z-index: 4;
    position: relative;
    .avatars-container {
      @media all and (max-width: $md) {
        margin-right: 0;
        justify-items: center;
        justify-content: center;
        align-content: flex-end;
        align-items: flex-end;
        align-self: flex-end;
      }
      justify-items: flex-end;
      justify-content: flex-end;
      align-content: flex-end;
      align-items: flex-end;
      align-self: flex-end;
      display: grid;
      grid-gap: 26px;
      grid-auto-flow: column;
      margin-right: 26px;
    }
    .avatar {
      @media all and (max-width: $md) {
        grid-column: 1 / span 8;
        position: relative;
        right: -64px;
      }
      transition: all 0.4s;
      width: 186px;
      height: 224px;
      align-self: flex-end;
      object-fit: cover;
      border-radius: 10px;
      grid-column: 6 / span 3;
      grid-row: 1;
      filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: gray;
      &.current {
        @media all and (max-width: $md) {
          width: 186px;
          height: 224px;
          box-shadow: unset;
          right: 0;
        }
        box-shadow: $float-shadow;
        filter: unset;
        -webkit-filter: unset;
        -moz-filter: unset;
        -ms-filter: unset;
        -o-filter: unset;
        filter: gray;
        width: 250px;
        height: 448px;
      }
      &.past {
        transform: translateX(0), scale(0);
        opacity: 0;
        right: -128px;
      }
      &.hidden {
        transform: translateX(0), scale(0);
        opacity: 0;
      }
      &.stop-animation {
        transition: unset;
      }
    }
  }
  .feedback-item {
    position: relative;
    @extend %switch-anim;
    @media all and (max-width: $md) {
      grid-row: 2;
      grid-column: 1 / span 12;
    }
    grid-row: 2;
    grid-column: 9 / span 4;
    align-self: center;
    align-content: flex-start;
    grid-gap: 20px;
    display: grid;
    &.current {
      position: relative;
      z-index: 2;
    }
    .feedback {
      @media all and (max-width: $md) {
        margin-left: 60px;
      }
    }
    .description {
      .title {
        font-size: 18px;
      }
      .more {
        font-size: 12px;
        grid-row: 2;
        color: $color-accent;
        margin-bottom: 17px;
      }
      .description-content {
        grid-gap: 10px;
      }
      margin-bottom: 40px;
    }
  }
  .nav-arrows {
    a {
      background: $bg-main;
      &:hover {
        background: $color-accent;
      }
    }
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      grid-row: 3;
      align-self: center;
      justify-self: flex-end;
      grid-template-columns: unset;
      margin-right: 26px;
    }
    z-index: 6;
    align-self: flex-end;
    grid-row: 2;
    grid-column: 9 / span 4;
    display: grid;
    grid-template-columns: repeat(2, 28px);
    grid-gap: 24px;
  }
  .quotes {
    @media all and (max-width: $md) {
      font-size: 64px;
      transform: translateX(-50%);
      z-index: 1;
      left: unset;
      top: 0px;
    }
    position: absolute;
    left: -460px;
    z-index: 1;
    top: -43px;

    font-size: 128px;
  }

  .float-art-right2 {
    pointer-events: none;
    @media all and (max-width: $md) {
      align-self: flex-start;
      grid-column: 1 / span 12;
      right: 00px;
      transform: translate(40%);
      top: -49px;
      width: 257px;
      height: 257px;
    }
    position: absolute;
    background: url(../assets/photos/contacts/rozh@2x.png) no-repeat right
      center;
    transform: translate(00px, 50%);
    right: calc((1088px - 100vw) / 2 - 120px);
    width: calc((100vw - 1088px) / 3 + 290px);
    height: calc((100vw - 1088px) / 3 + 290px);
    max-width: 600px;
    max-height: 600px;
    background-size: contain;
    align-self: flex-end;
  }
  .button-more {
    @media all and (max-width: $md) {
      display: grid;
      justify-self: center;
    }
    @extend %button-more;
    display: none;
  }
}
</style>
